import { Turbo } from "@hotwired/turbo-rails"

// Custom Turbo Stream action: close a dialog
// Usage: turbo_stream.action(:close_dialog, "dialog_id")
Turbo.StreamActions.close_dialog = function() {
  const dialogId = this.target
  const dialog = document.getElementById(dialogId)
  if (dialog instanceof HTMLDialogElement) {
    dialog.close()
  }
}

// Custom Turbo Stream action: dispatch a record-created event for searchable selects
// Usage: turbo_stream.action(:select_record, "storage_key", record_value: "123", record_label: "Name")
Turbo.StreamActions.select_record = function() {
  const storageKey = this.target
  const recordValue = this.getAttribute("record-value")
  const recordLabel = this.getAttribute("record-label")
  const previousValue = this.getAttribute("previous-value")

  document.dispatchEvent(new CustomEvent("record-created", {
    detail: {
      storageKey: storageKey,
      value: recordValue,
      label: recordLabel,
      previousValue: previousValue
    },
    bubbles: true
  }))
}

// Custom Turbo Stream action: reload a turbo frame
// Multiple reloads of the same frame in one render turn are coalesced.
// Usage: turbo_stream.action(:reload_frame, "frame_id")
const pendingFrameReloads = new Set()

Turbo.StreamActions.reload_frame = function() {
  const frameId = this.target
  if (pendingFrameReloads.has(frameId)) return

  pendingFrameReloads.add(frameId)
  queueMicrotask(() => {
    pendingFrameReloads.delete(frameId)
    const frame = document.getElementById(frameId)
    if (frame?.reload) frame.reload()
  })
}

